// Redux
import { connect } from "react-redux";
// Router
import { withRouter } from "react-router-dom";
// Component
import ManualDownload from "components/ManualDownload";
import { isAdmin } from "utils/formatter";

const mapStateToProps = () => ({
  isAdmin: isAdmin()
});

export default withRouter(connect(mapStateToProps)(ManualDownload));



// WEBPACK FOOTER //
// ./src/containers/ManualDownloadContainer.js